import { data } from "react-router-dom";
import { SAGA_ACTIONS } from "../../../_config";
import { useApiCall } from "../appApiCallHook";



export function useWorkOrderApi() {
  const callApi = useApiCall();

  const GetWOStatusList = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.WORK_ORDER.GET_WORK_STATUS_LIST, data, onSuccess, onError);
  };


  const GetWOPriorityList = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.WORK_ORDER.GET_WORK_PRIORITY_LIST, data, onSuccess, onError);
  };

  const GetWOMaintenanceTypeList = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.WORK_ORDER.GET_WORK_MAINTENANCE_LIST, data, onSuccess, onError);
  };

  const GetWOAssignmentTypeList = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.WORK_ORDER.GET_WORK_ASSIGNMENT_TYPE_LIST, data, onSuccess, onError);
  };

  const GetWOCode = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.WORK_ORDER.GET_WORK_CODE, data, onSuccess, onError);
  };


  const GetWorkOrderList = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.WORK_ORDER.GET_WORK_ORDER_LIST, data, onSuccess, onError);
  };


  const MoveStatus = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.WORK_ORDER.MOVE_STATUS, data, onSuccess, onError);
  };


  const GetWorkOrderByID = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.WORK_ORDER.GET_WORK_ORDER_BY_ID, data, onSuccess, onError);
  };

  const ExportToPDF = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.WORK_ORDER.EXPORT_TO_PDF, data, onSuccess, onError);
  };

  const ExportToXLS = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.WORK_ORDER.EXPORT_TO_XLS, data, onSuccess, onError);
  };

  const DeleteWorkOrder = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.WORK_ORDER.DELETE_WORK_ORDER, data, onSuccess, onError);
  };

  const GetWorkOrderAttachments = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.WORK_ORDER.GET_WORK_ATTACHMENT, data, onSuccess, onError);
  };


  const GetWorkOrderImages = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.WORK_ORDER.GET_WORK_IMAGES, data, onSuccess, onError);
  };

  const DeleteWorkOrderFiles = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.WORK_ORDER.DELETE_WORK_ORDER_FILES, data, onSuccess, onError);
  };

  const UploadImage = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.WORK_ORDER.UPLOAD_IMAGE, data, onSuccess, onError);
  };

  const UploadAttachment = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.WORK_ORDER.UPLOAD_ATTACHMENT, data, onSuccess, onError);
  };

  const SaveWorkOrder = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.WORK_ORDER.SAVE_WORK_ORDER, data, onSuccess, onError);
  };

  const SaveWorkOrderTaskDetails = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.WORK_ORDER.SAVE_WORK_ORDER_TASK_DETAILS, data, onSuccess, onError);
  };

  const GetWorkOrderNotesList = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.WORK_ORDER.GET_WORK_ORDER_NOTE_LIST, data, onSuccess, onError);
  };

  const SaveWorkOrderNotes = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.WORK_ORDER.SAVE_WORK_ORDER_NOTE_SAVE, data, onSuccess, onError);
  };

  const DeleteWorkOrderNotes = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.WORK_ORDER.DELETE_WORK_ORDER_NOTE, data, onSuccess, onError);
  };

  const GetWOTasks = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.WORK_ORDER.GET_WORK_ORDER_TASK, data, onSuccess, onError);
  };

  const GetWorkOrderCompletionByID = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.WORK_ORDER.GET_WORK_ORDER_COMPLETION_BY_ID, data, onSuccess, onError);
  };

  const GetWorkOrderCompletionAttachments = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.WORK_ORDER.GET_WORK_ORDER_COMPLETION_ATTACHMENTS, data, onSuccess, onError);
  };

  const SaveWorkOrderCompletion = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.WORK_ORDER.SAVE_WORK_ORDER_COMPLETION, data, onSuccess, onError);
  };
  const UploadWorkOrderCompletionAttachment = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.WORK_ORDER.SAVE_WORK_ORDER_COMPLETION_ATTACHMENT, data, onSuccess, onError);
  };

  const UpdateWorkOrderInprogress = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.WORK_ORDER.UPDATE_WORK_ORDER_INPROGRESS, data, onSuccess, onError);
  };


  const UpdateWorkOrderSchedule = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.WORK_ORDER.UPDATE_WORK_ORDER_SCHEDULE, data, onSuccess, onError);
  };

  const SaveWorkOrderAssets = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.WORK_ORDER.SAVE_WORK_ORDER_ASSETS, data, onSuccess, onError);
  };

  const SaveWorkOrderInventory = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.WORK_ORDER.SAVE_WORK_ORDER_INVENTORY, data, onSuccess, onError);
  };

  const InsertStockPicking = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.WORK_ORDER.WORK_ORDER_STOCK_PICKING, data, onSuccess, onError);
  };


  const SaveWorkOrderTasks = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.WORK_ORDER.SAVE_WORK_ORDER_ACTIVITY, data, onSuccess, onError);
  };

  const GetWorkOrderCompletionLog = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.WORK_ORDER.GET_WORK_ORDER_COMPLETION_LOG, data, onSuccess, onError);
  };



  const GetWorkOrderTaskLog = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.WORK_ORDER.GET_WORK_ORDER_TASK_LOG, data, onSuccess, onError);
  };

  const GetWOTaskLogExportToPDF = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.WORK_ORDER.WO_TASK_LOG_EXPORT_TO_PDF, data, onSuccess, onError);
  };

  const GetWOTaskLogExportToXLS = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.WORK_ORDER.WO_TASK_LOG_EXPORT_TO_XLS, data, onSuccess, onError);
  };

  const GetWorkOrderKanbanView = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.WORK_ORDER.GET_WORK_ORDER_KANBAN_VIEW, data, onSuccess, onError);
  };
  const RescheduleWorkOrder = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.WORK_ORDER.RESCHEDULE_WORK_ORDER, data, onSuccess, onError);
  };

  const SaveWOTaskAttachments = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.WORK_ORDER.WORK_ORDER_SAVE_TASK_ATTACHMENTS, data, onSuccess, onError);
  };  

  const GetPartsByWOID = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.WORK_ORDER.WORK_ORDER_GET_PARTS_BY_WO_ID, data, onSuccess, onError);
  };

  const CheckWOTasksCompletion = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.WORK_ORDER.CHECK_WO_TASKS_COMPLETION, data, onSuccess, onError);
  };

  return {
    GetWOStatusList,
    GetWOPriorityList,
    GetWOMaintenanceTypeList,
    GetWOAssignmentTypeList,
    GetWOCode,
    GetWorkOrderList,
    MoveStatus,
    GetWorkOrderByID,
    ExportToPDF,
    ExportToXLS,
    DeleteWorkOrder,
    GetWorkOrderAttachments,
    GetWorkOrderImages,
    DeleteWorkOrderFiles,
    UploadImage,
    UploadAttachment,
    SaveWorkOrder,
    SaveWorkOrderTaskDetails,
    GetWorkOrderNotesList,
    SaveWorkOrderNotes,
    DeleteWorkOrderNotes,
    GetWOTasks,
    GetWorkOrderCompletionByID,
    GetWorkOrderCompletionAttachments,
    SaveWorkOrderCompletion,
    UploadWorkOrderCompletionAttachment,
    UpdateWorkOrderInprogress,
    UpdateWorkOrderSchedule,
    SaveWorkOrderAssets,
    SaveWorkOrderInventory,
    InsertStockPicking,
    SaveWorkOrderTasks,
    GetWorkOrderCompletionLog,
    GetWorkOrderTaskLog,
    GetWOTaskLogExportToPDF,
    GetWOTaskLogExportToXLS,
    GetWorkOrderKanbanView,
    RescheduleWorkOrder,
    SaveWOTaskAttachments,
    GetPartsByWOID,
    CheckWOTasksCompletion
  };
}
